import { BasketOrder } from '../../../models/basket-order.model';

export class TooltipUtil {
  static getLateTooltipMessage(basketOrder: BasketOrder): { relaunchDate?: string; relaunchNumber: number } {
    const relaunchNumber = basketOrder.nbRelaunch ? basketOrder.nbRelaunch - 2 : 0;

    switch (basketOrder.nbRelaunch) {
      case 4:
        return {
          relaunchDate: basketOrder.dueDate?.add(5, 'days').format('DD/MM/YYYY'),
          relaunchNumber,
        };
      case 5:
        return {
          relaunchDate: basketOrder.dueDate?.add(6, 'days').format('DD/MM/YYYY'),
          relaunchNumber,
        };
      default:
        return {
          relaunchDate: basketOrder.dueDate?.format('DD/MM/YYYY'),
          relaunchNumber,
        };
    }
  }
}
